import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { not } from 'ember-truth-helpers';

import UiButton from '../ui-button';

import UiPaginationLabel from './label';

import UiPagination from './index';
import type { UiPaginationSignature } from './index';

type UiPaginationCombinedSignature = {
  Args: UiPaginationSignature['Args'];
  Element: HTMLDivElement;
};

export default <template>
  <UiPagination
    @pageCount={{@pageCount}}
    @pageNumber={{@pageNumber}}
    @pageSize={{@pageSize}}
    @recordCount={{@recordCount}}
    @setPageNumber={{@setPageNumber}}
    as |pagination|
  >
    <div class="w-full" ...attributes data-test-ui-pagination-combined>
      <div class="flex float-right">
        <UiPaginationLabel>
          <span class="text-sm text-carbon-50 mr-6">
            {{pagination.start}}&ndash;{{pagination.end}}
            of
            {{@recordCount}}
          </span>
        </UiPaginationLabel>
        <UiButton
          data-test-ui-pagination-first-page
          disabled={{not pagination.hasPreviousPage}}
          {{on "click" (fn @setPageNumber 1)}}
        >
          {{svgJar "chevron-grey-first" height="16" width="16" class="-mb-0.5 mx-3"}}
        </UiButton>
        <UiButton
          data-test-ui-pagination-previous-page
          disabled={{not pagination.hasPreviousPage}}
          {{on "click" pagination.goToPreviousPage}}
        >
          {{svgJar "chevron-grey-left" height="16" width="16" class="-mb-0.5 mx-3"}}
        </UiButton>
        <UiButton
          data-test-ui-pagination-next-page
          disabled={{pagination.isLastPage}}
          {{on "click" pagination.goToNextPage}}
        >
          {{svgJar "chevron-grey-right" height="16" width="16" class="-mb-0.5 mx-3"}}
        </UiButton>
        <UiButton
          data-test-ui-pagination-last-page
          disabled={{pagination.isLastPage}}
          {{on "click" (fn @setPageNumber @pageCount)}}
        >
          {{svgJar "chevron-grey-last" height="16" width="16" class="-mb-0.5 mx-3"}}
        </UiButton>
      </div>
    </div>
  </UiPagination>
</template> satisfies TOC<UiPaginationCombinedSignature>;
